import {connect} from "react-redux"
import {ColourwayData} from "models/searchApi"
import State from "../../models/state"
import {productPriceAriaLabelText} from "../../utils/colourwayBuilders"
import getTitleUtil from "../../utils/getTitleUtil"
import {CLEARANCE, MADE_TO_MEASURE, ProductType, SALE} from "../../config/constants"

export const mapStateToProps = (state: State) => {
    const {
        productSummary: {
            summaryData: {
                title,
                colourways,
                fit,
                department,
                brand,
                type: productType,
                markdownType,
                priceHistoryLength,
            },
            enabledSearchDesc,
            enableReviewStars,
            enableBrandDisplay,
            colourwaysHasStarRatingWithRangedPrice,
            colourwaysHasSale,
            brandedMarkdownSalePrice,
            useProductAggregator,
        },
        request: {isEnglishLang, pageType},
        text,
        template,
    } = state

    const selectedColourway = colourways.find(colourway => colourway.s) as ColourwayData
    const colourwayWithPersonalisedType = selectedColourway?.pt

    const getTitle = (
        useProductAggregator
            ? selectedColourway?.t
            : getTitleUtil({
                  enabledSearchDesc,
                  title,
                  selectedColourway,
                  fit,
                  department,
                  isEnglishLang,
                  type: productType,
              })
    ) as string

    const brandNameEnabled = enableBrandDisplay && brand !== null

    return {
        template,
        price: selectedColourway.p,
        wasPrice: selectedColourway?.wp,
        salePrice: selectedColourway?.sp,
        text,
        brandNameEnabled,
        isMade2Measure: colourwayWithPersonalisedType === MADE_TO_MEASURE,
        minPrice: selectedColourway.mp,
        productPriceAriaLabelText: productPriceAriaLabelText({
            title: getTitle,
            price: selectedColourway?.p || "",
            salePrice: selectedColourway?.sp,
            wasPrice: selectedColourway?.wp,
            salePriceText: text.price.now,
            wasPriceText: text.price.was,
            isEnglishLang,
        }),
        isWasPriceARange: selectedColourway?.wp?.includes("-") || false,
        enableReviewStars: enableReviewStars ? productType === ProductType : false,
        isPriceARange: selectedColourway?.p?.includes("-") || false,
        overallStarRating: selectedColourway?.st || 0,
        colourwaysHasStarRatingWithRangedPrice,
        colourwaysHasSale,
        brandedMarkdownSalePrice,
        showSpecialOffer: [CLEARANCE, SALE].includes(markdownType ?? "") && priceHistoryLength === 1,
        saleOrClearance: pageType,
    }
}

export default connect(mapStateToProps)
